import { Controller } from "@hotwired/stimulus";

export default class MaxAmountController extends Controller {
  static targets = ["textinput"];

  static values = {
    max: Number,
    min: Number,
  }

  connect(){
    // Add input event listener to validate against max value
    if (this.hasTextinputTarget) {
      this.textinputTarget.addEventListener('input', this.validateAmount.bind(this));
    }
  }

  insertMaxAmount(){
    if (this.hasTextinputTarget && this.hasMaxValue) {
      // Use max amount, but ensure it's at least the minimum value
      const amountToInsert = Math.max(this.maxValue, this.minValue);
      this.textinputTarget.value = amountToInsert.toFixed(2);
      this.textinputTarget.focus();

      // Trigger input event so other controllers (like money controller) can respond
      this.textinputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  validateAmount(event) {
    if (!this.hasMaxValue) return;

    const inputValue = Number.parseFloat(event.target.value);
    
    // Only validate max if the input is a valid number and exceeds max
    if (!Number.isNaN(inputValue) && inputValue > this.maxValue) {
      event.target.value = this.maxValue.toFixed(2);

      // Trigger input event so other controllers can respond to the capped value
      event.target.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (!Number.isNaN(inputValue) && inputValue < this.minValue) {
      const inputString = event.target.value;
      const isCompleteDecimal = /^\d+\.\d{2}$/.test(inputString); // e.g., "1.50", "12.34"
      const isLargeWholeNumber = /^\d{2,}$/.test(inputString); // e.g., "10", "100", "1000"

      if (isCompleteDecimal || isLargeWholeNumber) {
        event.target.value = this.minValue.toFixed(2);

        // Trigger input event so other controllers can respond to the capped value
        event.target.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }

}